import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import { exhaustMap, map, catchError } from 'rxjs/operators';

import { toPayload } from 'app/helpers';

import { TrackingPageDataService } from './tracking-page-data.service';
import { of, empty } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  TrackingPageActionTypes as types,
  BootstrapTrackingPage,
  BootstrapTrackingPageSuccess,
  SetTrackingPage,
  NoTrackingNumberFound
} from './tracking-page.actions';
import { Router } from '@angular/router';

@Injectable()
export class TrackingPageEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private trackingPageData: TrackingPageDataService
  ) {}

  readonly fetchTrackingPageBySubdomain$ = createEffect(() =>
    this.actions$.pipe(
      ofType(types.FETCH_TRACKING_PAGE_BY_SUBDOMAIN),
      toPayload(),
      exhaustMap(this.fetchTrackingPageBySubdomain())
    )
  );

  readonly findTrackingPageNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(types.FIND_TRACKING_PAGE_NUMBER),
      toPayload(),
      exhaustMap(this.findTrackingPageNumber())
    )
  );

  readonly bootstrapTrackingPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<BootstrapTrackingPage>(types.BOOTSTRAP),
      toPayload(),
      exhaustMap(this.bootstrapTrackingPage())
    )
  );

  private fetchTrackingPageBySubdomain() {
    return params =>
      this.trackingPageData.fetchTrackingPageBySubdomain(params).pipe(
        map(data => new SetTrackingPage(data)),
        catchError(() => {
          if (params.redirectOnError !== false) {
            window.location.href = environment.domainNotFoundRedirect;
          }
          return empty();
        })
      );
  }

  private bootstrapTrackingPage() {
    return params =>
      this.trackingPageData.bootstrapTrackingPage(params).pipe(
        map(data => new BootstrapTrackingPageSuccess(data)),
        catchError(() => {
          if (params.redirectOnError !== false) {
            this.router.navigate(['/tracking-page/search']);
          }
          return empty();
        })
      );
  }

  private findTrackingPageNumber() {
    return payload =>
      this.trackingPageData.findTrackingPageNumber(payload).pipe(
        exhaustMap(({ link, text }) => {
          console.log(text);
          if (link) {
            window.location.href = link;
            return empty();
          }

          return of(new NoTrackingNumberFound(text));
        }),
        catchError(e => {
          return of(new NoTrackingNumberFound());
        })
      );
  }
}
